import { Box } from '@mui/material';
import { DicomColor } from '~/domain/dicom/dicomColor';
import TargetIcon from './TargetIcon';

export default function RoiColor({
    color,
    size = 12,
    opacity = 1,
    isEmptyVolume = false,
    isMarker = false,
    isTarget = false,
}: {
    color: DicomColor;
    size?: number;
    opacity?: number;
    isEmptyVolume?: boolean;
    isMarker?: boolean;
    isTarget?: boolean;
}) {
    const { R, G, B } = color;
    const colorValue = `rgba(${R}, ${G}, ${B}, ${opacity})`;

    if (isTarget) {
        return <TargetIcon color={colorValue} size={11} />;
    }
    /** When true, renders a small filled dot to represent a point/marker ROI. */
    if (isMarker) {
        const c = size / 2;
        return (
            <svg
                width={size}
                height={size}
                viewBox={`0 0 ${size} ${size}`}
                style={{ flexShrink: 0 }}
            >
                {/* Outer ring */}
                <circle
                    cx={c}
                    cy={c}
                    r={c - 0.75}
                    fill="none"
                    stroke={colorValue}
                    strokeWidth={1}
                />
                {/* Center dot */}
                <circle cx={c} cy={c} r={size * 0.18} fill={colorValue} />
            </svg>
        );
    }

    return (
        <Box
            sx={{
                width: size,
                height: size,
                backgroundColor: isEmptyVolume ? 'transparent' : colorValue,
                borderRadius: '50%',
                border: isEmptyVolume ? 2 : 0,
                borderColor: colorValue,
                boxSizing: 'border-box',
            }}
        />
    );
}
